import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * API client. Auth is handled exclusively via httpOnly cookies set by the
 * backend on /api/auth/login. We never store tokens in localStorage to avoid
 * XSS exposure. `withCredentials: true` ensures the browser includes cookies
 * on every request (same-origin in this deployment).
 */
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
